/* eslint-disable @typescript-eslint/no-explicit-any */
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ListPageTopBar } from "@/components/layout/dashboard-layout";
import { useTable } from "@/hooks/useTable";
import { ListFooter } from "@/components/shared/list-footer";

import { ErrorBoundary } from "react-error-boundary";
import { RecordNotFound } from "@/components/shared/record-not-found";
import { TableColumnsHandle } from "@/components/shared/table-columns-handle";
import { Columns3Icon, /* Download, */ FilterIcon, X } from "lucide-react";
import { useMutations } from "./utils/react-hook/use-mutations";
import { ReactTable, ReactTableSkelton } from "./utils";
import { Fragment } from "react/jsx-runtime";
import ErrorFallback from "@/components/shared/error-fallback";
import { IconRender } from "@/components/shared/Icon-render";
import { documents } from "@/services/global.services";
import { DocumentDetails } from "./details";
import { ConditionRenderer } from "@/components/shared/condition-renderer";
import { DocumentUploadDetailsForm } from "./utils/document-upload-form/document-upload-form";
import { Switch } from "@/components/ui/switch";
import { RangeDateSelector } from "@/components/form-input/range-date-selector";
import { cn } from "@/lib/utils";
import { DateRangeByFilter } from "./utils/date-range-by-filter";
import { useUserInfo } from "@/global-data/use-user-info";
import { DocumentStatistics } from "./utils/document-statistics";
// import { MultiSelectWithSearchV3 } from "@/components/form-input/multi-select-with-search-v3";
export const Document = () => {
  const {
    listData,
    onPageChange,
    onPerPageChange,
    paginationData,
    permission,
    onAction,
    skeltonLoading,
    tableColumn,
    setTableColumn,
    retailerList,
    filter,
    setFilter,
    filterRequest,
    clearFilter,
    formPopup,
    setFormPopup,
    formSubmitHandle,
    workflowList,
    currentCompanyData,
    reprocessDocumentId,
    reprocessErpId,
    onDateChange,
    autoPolling,
    setAutoPolling,
    dateFilter,
    company_id,
    user_id,
    loadingList,
    parent_id,
    handleDateRangeBy,
    dateRangeBy,
    dashboardDetails,
    // selectedRecord,
    // setSelectedRecord,
    // cashBalanceReport,
    // allRetailerList,
    // isAdmin,
    // currentUser,
    onTempDateChange,
    allRetailerList,
  } = useMutations();

  const support_multi_doc_type =
    currentCompanyData?.settings?.support_multi_doc_type;
  const show_deleted_documents =
    currentCompanyData?.settings?.show_deleted_documents === true;

  const view_list = [
    "source_type",
    "retailer_name",
    "outlet_name",
    "sales_report_date",
    "net_sales",
    "cash_sales",
    "expenses",
    "bank_in_amount",
    "state",
    "reference_number",
    "erp_ref_number",
    "erp_info",
    "erp_status",
    "uts",
    "erp_customer_info",
    "erp_customer_name",
    "modified_by",
    "is_flagged",
    "has_child",
    "transitions",
    "doc_type",
    "doc_id",
    "order_date",
    "delivery_date",
  ];

  const avoid_list = [
    "bank_in_amount",
    "cash_sales",
    "expenses",
    "net_sales",
    "outlet_name",
    "sales_report_date",
    "doc_id",
  ];

  const { tableHeader, table, tableKeys, onResize, onSorting } = useTable({
    data: listData,
    view: view_list,
    verifyKey: support_multi_doc_type ? documents.key + "1" : documents.key,
    visible: tableColumn,
    avoid: ["doc_id"],
    columnSize: {
      source_type: 65,
      bank_in_amount: 140,
      cash_sales: 100,
      expenses: 100,
      net_sales: 100,
      outlet_name: 100,
      is_flagged: 65,
      retailer_id: 105,
      reference_number: 105,
      erp_ref_number: 105,
      erp_status: 195,
      erp_info: 120,
      state: 150,
      doc_type: 110,
      uts: 150,
      modified_by: 100,
      transitions: 100,
      has_child: 70,
      erp_customer_info: 200,
      erp_customer_name: 200,
      sales_report_date: 140,
    },
  });

  const { activePermission, permission: permission_list } = useUserInfo();

  const upload_document_allow = permission_list.find((item: any) =>
    ["upload_document", "upload_documnent"].includes(item.name),
  );

  return (
    <Fragment>
      <div className="flex flex-col gap-5">
        <ListPageTopBar title="Document">
          <div
            className={cn(
              parent_id
                ? "hidden"
                : "flex items-center flex-wrap py-3 justify-end gap-3",
            )}
          >
            <div className=" gap-2 pr-3 items-center hidden">
              <Switch
                checked={autoPolling}
                onCheckedChange={(prop) => setAutoPolling(prop)}
              />
              <span className="text-sm">Auto Poll</span>
            </div>
            <DateRangeByFilter
              handleDateRangeBy={handleDateRangeBy}
              dateRangeBy={dateRangeBy}
            />
            <RangeDateSelector
              defaultValue={dateFilter}
              onChange={onDateChange}
              onTempDateChange={onTempDateChange}
              isDocument={true}
            />
            <TableColumnsHandle
              tableKeys={tableKeys}
              tableColumn={tableColumn}
              setTableColumn={setTableColumn}
              onSorting={onSorting}
              avoid_list={support_multi_doc_type ? [] : avoid_list}
              // tableKey={documents.key}
              labels={{
                retailer_id: "Retailer Name",
                transitions: "Transitions",
                erp_status: "Details",
                state: "Status",
                has_child: "Has Child",
                erp_customer_info: "ERP Customer Info",
                erp_customer_name: "Erp Customer Name",
                doc_type: "Doc Type",
                source_type: "Source",
                erp_info: "Erp ref #",
                doc_id: "Doc Id",
                erp_ref_number: "SNC Ref #",
                reference_number: "Reference #",
                modified_by: "Modified By",
                // "file_path",
                is_flagged: "Is Flagged",
                uts: "Processed On",
                bank_in_amount: "Bank in Amount",
                cash_sales: "Cash Sales",
                expenses: "Expenses",
                net_sales: "Net Sales",
                sales_report_date: "Sales Report Date",
                outlet_name: "Outlet Name",
              }}
            >
              <Columns3Icon /> Column
            </TableColumnsHandle>

            <ConditionRenderer condition={Object.keys(filter).length !== 0}>
              <>
                <Button onClick={() => filterRequest()} variant={"action"}>
                  <FilterIcon /> Filter
                </Button>
                <Button variant={"action"} onClick={clearFilter}>
                  <X /> Clear Filter
                </Button>
              </>
            </ConditionRenderer>

            <Button
              className="relative"
              variant={"action"}
              onClick={() => setFormPopup(true)}
              disabled={upload_document_allow?.create !== true}
            >
              <IconRender name="Upload" strokeWidth={1.5} /> Upload
            </Button>
          </div>
        </ListPageTopBar>
        {skeltonLoading ? (
          <ReactTableSkelton />
        ) : (
          <Card className="overflow-hidden">
            <CardContent className="max-w-[100%] p-0 overflow-auto scrollbar h-auto min-h-[350px] md:h-[calc(100dvh-208px)]">
              <ErrorBoundary
                fallbackRender={({ error, resetErrorBoundary }) => (
                  <ErrorFallback
                    error={error}
                    errorInfo={error.stack || ""}
                    resetErrorBoundary={resetErrorBoundary}
                  />
                )}
              >
                {dashboardDetails && !parent_id ? (
                  <DocumentStatistics
                    dashboard_details={dashboardDetails}
                    totalItem={(dashboardDetails as any)?.totalCount}
                    filter={filter}
                    setFilter={setFilter}
                    filterRequest={filterRequest}
                    showDeletedDocuments={show_deleted_documents}
                  />
                ) : null}
                <ReactTable
                  tableHeader={tableHeader}
                  onResize={onResize}
                  table={table}
                  permission={permission}
                  onAction={onAction}
                  retailerList={retailerList}
                  filter={filter}
                  setFilter={setFilter}
                  listData={listData}
                  filterRequest={filterRequest}
                  workflowList={workflowList}
                  currentCompanyData={currentCompanyData}
                  reprocessDocumentId={reprocessDocumentId}
                  reprocessErpId={reprocessErpId}
                  company_id={company_id}
                  user_id={user_id}
                  loadingList={loadingList}
                  activePermission={activePermission}
                  allRetailerList={allRetailerList}
                />
                {table.length === 0 ? <RecordNotFound /> : null}
              </ErrorBoundary>
            </CardContent>
            <ErrorBoundary
              fallbackRender={({ error, resetErrorBoundary }) => (
                <ErrorFallback
                  error={error}
                  errorInfo={error.stack || ""}
                  resetErrorBoundary={resetErrorBoundary}
                />
              )}
            >
              <hr />
              <ListFooter
                onPageChange={onPageChange}
                onPerPageChange={onPerPageChange}
                page={paginationData.page}
                perPage={paginationData.perPage}
                totalItem={paginationData.totalItem}
                className="px-5 py-5"
                isEmpty={table.length === 0}
              />
            </ErrorBoundary>
          </Card>
        )}
      </div>
      <ConditionRenderer condition={formPopup}>
        <DocumentUploadDetailsForm
          formData={{}}
          onOpenChange={setFormPopup}
          onFormSubmit={formSubmitHandle}
          open={formPopup}
          workflowList={workflowList}
          company_id={company_id}
          user_id={user_id}
          currentCompanyData={currentCompanyData}
          allRetailerList={allRetailerList}
        />
      </ConditionRenderer>
    </Fragment>
  );
};

Document.Details = DocumentDetails;
